<h1 mat-dialog-title>
  {{ ("cancelTime" | i18n) || "Absagezeitpunkt" }}
</h1>
<div mat-dialog-content>
  <div class="form-row">
    <mat-form-field class="light-form-field">
      <mat-label>{{ ("date" | i18n) || "Datum" }}:</mat-label>
      <input
        matInput
        type="date"
        [(ngModel)]="date"
        data-cy="manual-cancel-date" />
    </mat-form-field>
    <mat-form-field class="light-form-field">
      <mat-label>{{ ("timeOfDay" | i18n) || "Uhrzeit" }}:</mat-label>
      <input
        matInput
        type="time"
        [(ngModel)]="time"
        data-cy="manual-cancel-time" />
    </mat-form-field>
  </div>
</div>
<div mat-dialog-actions>
  <button
    mat-button
    (click)="close()">
    {{ ("close" | i18n) || "CLOSE" | uppercase }}
  </button>
  <button
    mat-button
    (click)="submit()"
    data-cy="manual-cancel-time-submit">
    {{ ("confirm" | i18n) || "CONFIRM" | uppercase }}
  </button>
</div>
